import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { CarouselComponent } from "./carousel.component";

const materialModules = [MatIconModule];

@NgModule({
  declarations: [CarouselComponent],
  imports: [CommonModule, ...materialModules],
  exports: [CarouselComponent],
})
export class CarouselModule {}
